import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts/highstock';
import * as React from 'react';
import styled from 'styled-components';

import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const HighChart = ({ ...props }: HighchartsReact.Props) => {
    const wrapperRef = React.useRef<HTMLDivElement>(null);
    const [width, setWidth] = React.useState(0);

    const updateWidth = () => {
        setWidth(wrapperRef.current?.getBoundingClientRect().width || 0);
    }
    useApiListener(Event.resizeSidebar, updateWidth);

    React.useEffect(() => {
        if (wrapperRef.current) {
            updateWidth();
        }
    }, [wrapperRef]);

    const getSeriesLength = (singleSeries) =>
        'data' in singleSeries ? singleSeries.data.length : 0;

    const series = props.options.series.map((singleSeries) => ({
        ...singleSeries,
        turboThreshold: getSeriesLength(singleSeries),
    }));

    const chartKey = `${width}@${series.map(getSeriesLength).join('@')}`;

    return (
        <Wrapper ref={wrapperRef}>
            <HighchartsReact
                key={chartKey}
                {...props}
                options={{ ...props.options, series }}
                highcharts={Highcharts}
                containerProps={{ style: { height: '650px', width: '100%' } }}                
            />
        </Wrapper>
    );
};
